import { AppState } from 'redux/rootReducer'
import { createSelector } from '@reduxjs/toolkit'

const selectFilter = (state: AppState) => state.bienAVendreResultFilter

const selectBienAVendreResultFilter = createSelector(
  selectFilter,
  (substate) => substate
)

export const makeSelectBienAVendreNameFilter = createSelector(
  selectFilter,
  (substate) => substate.filter
)

export default selectBienAVendreResultFilter
